/**
 * Can be used for exhaustive pattern matching
 *
 *     type Union = 'A' | 'B'
 *     const printUnion = (x: Union) => {
 *       switch (x) {
 *         case 'A':
 *           return 'A'
 *         case 'B':
 *           return 'B'
 *         default:
 *           return assertNever(x)
 *       }
 *     }
 */
export const assertNever = (value: never): never => {
  throw Error(`Unreachable case ${value}`)
}
